<template>
  <span :class="['status-badge', `status-badge--${semantic}`, { 'status-badge--text': variant === 'text' }]">
    <span v-if="dot" class="status-badge__dot" :style="{ background: dotColor }" />
    <span class="status-badge__label">{{ status }}</span>
  </span>
</template>

<script>
/**
 * 가이드 §5.5 — 상태 배지.
 * 라벨 텍스트가 1차 식별 채널, 색은 보조.
 */
const STATUS_MAP = {
  // payStatus
  "견적발급": { semantic: "info",    dotColor: "#1B3F8A" },
  "결제확정": { semantic: "warning", dotColor: "#92560A" },
  "결제진행": { semantic: "warning", dotColor: "#B36A00" },
  "결제완료": { semantic: "success", dotColor: "#1F7A3A" },

  // accountStatus
  "안내필요": { semantic: "neutral", dotColor: "#7A828F" },
  "정보대기": { semantic: "info",    dotColor: "#1B3F8A" },
  "발급필요": { semantic: "warning", dotColor: "#92560A" },
  "발급완료": { semantic: "success", dotColor: "#1F7A3A" },
};

export default {
  name: "StatusBadge",
  props: {
    status: { type: String, required: true },
    dot: { type: Boolean, default: true },
    // "badge"(기본, 알약 배경) | "text"(배경 없이 상태 색상 글씨만)
    variant: { type: String, default: "badge" },
  },
  computed: {
    mapping() {
      const m = STATUS_MAP[this.status];
      if (!m) {
        // eslint-disable-next-line no-console
        console.warn(`[StatusBadge] unknown status "${this.status}" — fallback to neutral`);
        return { semantic: "neutral", dotColor: "#7A828F" };
      }
      return m;
    },
    semantic() { return this.mapping.semantic; },
    dotColor() { return this.mapping.dotColor; },
  },
};
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  height: 22px;
  padding: 2px 8px;
  border-radius: var(--radius-pill);
  font-size: var(--font-caption-size);
  line-height: 1;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid transparent;
}

.status-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-badge__label {
  display: inline-block;
}

.status-badge--success {
  background: var(--color-success-bg);
  color: var(--color-success-text);
  border-color: var(--color-success-border);
}
.status-badge--warning {
  background: var(--color-warning-bg);
  color: var(--color-warning-text);
  border-color: var(--color-warning-border);
}
.status-badge--error {
  background: var(--color-error-bg);
  color: var(--color-error-text);
  border-color: var(--color-error-border);
}
.status-badge--info {
  background: var(--color-info-bg);
  color: var(--color-info-text);
  border-color: var(--color-info-border);
}
.status-badge--neutral {
  background: var(--color-neutral-bg);
  color: var(--color-neutral-text);
  border-color: var(--color-neutral-border);
}

.status-badge--text {
  height: auto;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
  background: transparent !important;
  border-color: transparent !important;
}
</style>
